import { useEffect, useState } from 'react'
import * as THREE from 'three'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader'
import { ViewerConfig } from '../../../../trillion-common/src/objects/viewer-config.object'
import { getResourcePath } from '../../../../trillion-common/src/API/storageAPI'

export function useCubeMap(
  config: ViewerConfig | undefined,
  scene: THREE.Scene,
  reflectionMap?: string,
) {
  const [cubeMap, setCubeMap] = useState<THREE.DataTexture | undefined>(undefined)

  function reflectionMapResolver() {
    if (reflectionMap) {
      return reflectionMap
    }

    if (config?.reflectionMap?.reflectionMap) {
      return config.reflectionMap.reflectionMap
    }

    return getResourcePath('environment_new_dark.hdr')
  }

  useEffect(() => {
    if (!config) return
    const path = reflectionMapResolver()
    new RGBELoader().loadAsync(path).then((cubeMap) => {
      setCubeMap(cubeMap)
    })
  }, [config, reflectionMap])

  useEffect(() => {
    if (!cubeMap) return
    cubeMap.mapping = THREE.EquirectangularReflectionMapping
    scene.environment = cubeMap
  }, [cubeMap, scene])

  return cubeMap
}
